import { dom, library } from '@fortawesome/fontawesome-svg-core';
import { faSpinnerThird, faTable } from '@fortawesome/pro-light-svg-icons';
import { faSpinner, faSquare } from '@fortawesome/pro-regular-svg-icons';
import { fas } from '@fortawesome/pro-solid-svg-icons';

library.add(faSpinnerThird, faTable, faSquare, faSpinner, fas);
dom.watch();
